import axios from 'axios';
import { resolveBackendBaseUrl } from '../../../utils/runtimeConfig';

export const API = `${resolveBackendBaseUrl()}/api`;

export const getHeaders = () => {
  const token = localStorage.getItem('ktc_token') || localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const toNumber = (value, fallback = 0) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};

export const fetchOwners = async () => {
  try {
    const response = await axios.get(`${API}/voucher/owners`, { headers: getHeaders() });
    if (Array.isArray(response.data?.items)) return response.data.items;
    if (Array.isArray(response.data)) return response.data;
    return [];
  } catch {
    return [];
  }
};

export const fetchRouters = async () => {
  try {
    const response = await axios.get(`${API}/routers`, { headers: getHeaders() });
    return Array.isArray(response.data) ? response.data : [];
  } catch {
    return [];
  }
};
